import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=640cb46d&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('640cb46d')) {
      api.createRecord('640cb46d', component.options)
    } else {
      api.reload('640cb46d', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=640cb46d&", function () {
      api.rerender('640cb46d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2XfSweHEg8jRA/JS/offershelp.vue"
export default component.exports